/* @flow */
export const setDisplayMode = (displayMode: boolean) => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'displayMode',
        value: displayMode
    };
};

export const setFilterDisplayMode = (displayMode: boolean) => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'filterDisplayMode',
        value: displayMode
    };
};

export const setProductId = (id: string) => {
    return {
        type: 'SET_VALUE',
        identifier: 'data.selectedProductId',
        value: id,
        stateKey: 'vertical.quote'
    };
};

export const setQuoteId = (quoteId: number) => {
    return {
        type: 'SET_VALUE',
        identifier: 'data.quoteId',
        value: quoteId,
        stateKey: 'vertical.quote'
    };
};

export const nextPage = (pageNumber: number) => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'pageNumber',
        value: pageNumber + 1
    };
};

export const prevPage = (pageNumber: number) => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'pageNumber',
        value: pageNumber - 1
    };
};

export const startPage = () => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'pageNumber',
        value: 1
    };
};

export const toggleAccordionRow = (id: string, value: boolean) => {
    return {
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: `featuresModeAccordionOpenState.${id}`,
        value
    };
};

export const toggleAccordion = (id, isOpen) => ({
    type: 'TOGGLE_ACCORDION',
    payload: {
        id,
        isOpen
    }
});
